import { createSelector } from 'reselect';
import { deliverySelector } from 'redux/modules/delivery';

export const userAddressIdSelector = createSelector(
  deliverySelector,
  delivery => delivery.userAddressId,
);
